const dummyData = [
  {
    id: 1,
    name: "John Doe",
    role: "Founder",
    description: "this is just a place holder for the person to be created",
    image: "https://via.placeholder.com/150",
  },
  {
    id: 2,
    name: "Jane Smith",
    role: "Designer",
    description: "this is just a place holder for the person to be created",
    image: "https://via.placeholder.com/150",
  },
  {
    id: 3,
    name: "Bob Johnson",
    role: "Developer",
    description: "this is just a place holder for the person to be created",
    image: "https://via.placeholder.com/150",
  },
];

export default dummyData;
